import { render, staticRenderFns } from "./highQuality_organization.vue?vue&type=template&id=1a5fc0f7&scoped=true&"
import script from "./highQuality_organization.vue?vue&type=script&lang=ts&"
export * from "./highQuality_organization.vue?vue&type=script&lang=ts&"
import style0 from "./highQuality_organization.vue?vue&type=style&index=0&id=1a5fc0f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5fc0f7",
  null
  
)

export default component.exports